<template>
    <section class="contact-web-profile">
        <h3>{{ $options.WEB_PROFILE }}</h3>

        <div v-if="isContactHasProfileDetails" data-qa="web-profile-data">
            <div
                v-for="(visitor, index) in visitorsList"
                :key="index"
            >
                <div class="web-profile-header">
                    <p class="visitor-name">
                        {{ $options.VISITOR }} {{ visitor.id }}
                    </p>

                    <ds-outline-button data-qa="view-all-page-views" @click="viewAllPage(visitor.id)">
                        {{ $options.PAGE_VIEWS }}
                    </ds-outline-button>
                </div>

                <div class="profile-visitors-data">
                    <ul>
                        <li>{{ $options.PROFILE_DATA.ORIGINAL_REFERRER }} <span>{{ visitor.originalReferrer }}</span></li>

                        <li>{{ $options.PROFILE_DATA.LEAD_SOURCE }} <span>{{ visitor.leadSource }}</span></li>

                        <li>{{ $options.PROFILE_DATA.SCREEN_RESOLUTION }} <span>{{ visitor.screenResolution }}</span></li>

                        <li>{{ $options.PROFILE_DATA.LAST_VISIT_DATE }} <span>{{ visitor.lastVisitDate }}</span></li>
                    </ul>

                    <ul>
                        <li>{{ $options.PROFILE_DATA.OS }}<span>{{ visitor.os }}</span></li>

                        <li>{{ $options.PROFILE_DATA.BROWSER }}<span>{{ visitor.browser + visitor.browserVersion }}</span></li>

                        <li>{{ $options.PROFILE_DATA.PLUGINS }}<span>{{ visitor.plugins }}</span></li>

                        <li>{{ $options.PROFILE_DATA.DATE_CREATED }}<span>{{ visitor.dateCreated }}</span></li>
                    </ul>
                </div>

                <contact-web-profile-table :viewed-urls="visitor.contactPageViewList" />
            </div>
        </div>

        <div v-else class="no-visitors-label">
            {{ $options.EMPTY_TABLE_MESSAGE }}
        </div>

        <contact-web-profile-modal
            ref="webProfileViewAll"
            :visitor-id="visitorId"
        />
    </section>
</template>

<script>
import ContactWebProfileModal from './ContactWebProfileModal';
import ContactWebProfileTable from './ContactWebProfileTable';
import axios from 'axios';

const WEB_PROFILE = 'Web profile';
const VISITOR = 'Visitor';
const PAGE_VIEWS = 'View All Page Views';
const EMPTY_TABLE_MESSAGE = 'This Contact does not have any Visitors';
const PROFILE_DATA = {
    ORIGINAL_REFERRER: 'Original Referrer',
    LEAD_SOURCE: 'Lead Source',
    SCREEN_RESOLUTION: 'Screen Resolution',
    LAST_VISIT_DATE: 'Last Visit date/time',
    OS: 'OS',
    BROWSER: 'Browser',
    PLUGINS: 'Plugins',
    DATE_CREATED: 'Date Created',
};

export default {
    WEB_PROFILE,
    VISITOR,
    PAGE_VIEWS,
    PROFILE_DATA,
    EMPTY_TABLE_MESSAGE,

    components: {
        ContactWebProfileTable,
        ContactWebProfileModal,
    },

    props: {
        contact: Object,
    },

    data() {
        return {
            url: '/app/webTracking',
            visitorsList: [],
            visitorId: 0,
        };
    },

    created() {
        this.loadWebProfile();
    },

    computed: {
        isContactHasProfileDetails() {
            return Boolean(this.visitorsList?.length);
        },
    },

    methods: {
        async loadWebProfile() {
            try {
                const response = await axios.get(`${this.url}/contactWebProfile/${this.contact.id}`);

                this.visitorsList = response.data;
            } catch (error) {
                this.$error({ message: 'Unable to get profile data for this contact' });
            }
        },

        viewAllPage(visitorId) {
            this.visitorId = visitorId;
            this.$refs.webProfileViewAll.loadVisitors(visitorId);
            this.$refs.webProfileViewAll.showModal(0);
        },
    },
};
</script>

<style lang="scss" scoped>
.contact-web-profile {
    h3 {
        padding: $spacing-300 0;
        border-bottom: 1px solid $color-gray-lighter;
    }

    .no-visitors-label {
        color: $color-gray-darker;
        font-size: $font-size-xl;
        font-weight: $font-weight-headlines;
        padding-top: $spacing-800;
        padding-bottom: $spacing-600;
        display: flex;
        justify-content: center;
    }

    .visitor-name {
        font-size: $font-size-lg;
        margin-bottom: 0;
    }

    .web-profile-header {
        display: flex;
        justify-content: space-between;
        padding: $spacing-200 0;
        align-items: center;
    }

    .profile-visitors-data {
        display: flex;
        margin-bottom: $spacing-200;
        ul {
            width: 50%;
            li {
                font-weight: $font-weight-bold;
                padding: 0.6rem 0;
                span {
                    margin-left: $spacing-200;
                    font-weight: normal;
                }
            }
        }
    }

    @media($small) {
        .profile-visitors-data {
            display: block;
            ul {
                width: 100%;
            }
        }
    }
}
</style>
